import type { ReactNode } from 'react';
import { isNativePlatform } from '../../utils/platform';
import WebOnlyNotice from '../../pages/WebOnlyNotice';

/**
 * Wraps a route so it renders `WebOnlyNotice` instead of its children when the
 * app is running inside a Capacitor native shell. Used to keep billing,
 * purchase and payment-config pages out of iOS / Android builds for App Store
 * and Play Store compliance.
 */
function WebOnlyRoute({ children }: { children: ReactNode }) {
  if (isNativePlatform()) return <WebOnlyNotice />;
  return <>{children}</>;
}

export default WebOnlyRoute;
